import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ShieldExclamationIcon, ArrowLeftOnRectangleIcon, HomeIcon } from '@heroicons/react/24/outline';
import { useSelector, useDispatch } from 'react-redux';
import { logout } from '../store/slices/authSlice';
import { Button } from '../components/Common';

const Unauthorized = () => {
  const { user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(logout());
    navigate('/login');
  };

  // Check if user is a viewer (no admin portal access)
  const isViewer = user?.primaryRole?.code === 'VIEWER' || user?.role === 'VIEWER';
  
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-100 p-4">
      <div className="text-center max-w-lg">
        <div className="w-24 h-24 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <ShieldExclamationIcon className="w-12 h-12 text-red-600" />
        </div>
        <h1 className="text-3xl font-bold text-slate-800 mb-2">Access Denied</h1>
        
        {isViewer ? (
          <>
            <p className="text-slate-500 mb-4">
              Your account has <strong>Viewer</strong> role which does not have access to the admin panel.
            </p>
            <p className="text-slate-500 mb-8">
              Please contact your administrator to upgrade your account if you need admin access.
            </p>
          </>
        ) : (
          <p className="text-slate-500 mb-8">
            You don't have permission to access this page. Please contact your administrator if you believe this is an error.
          </p>
        )}

        {user && (
          <div className="bg-white rounded-xl p-4 mb-6 shadow-sm">
            <p className="text-sm text-slate-600">
              Logged in as: <strong>{user.email}</strong>
            </p>
            <p className="text-sm text-slate-600">
              Role: <strong>{user.primaryRole?.name || user.role || 'Unknown'}</strong>
            </p>
          </div>
        )}

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          {!isViewer && (
            <Link to="/dashboard">
              <Button icon={HomeIcon}>Return to Dashboard</Button>
            </Link>
          )}
          <Button variant="secondary" icon={ArrowLeftOnRectangleIcon} onClick={handleLogout}>
            Logout & Switch Account
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;
